import { BioIntro, BioTimeline, BioObjective, BioSkills } from "./bio/BioParts";

export const Bio = () => (
  <section id="parcours" className="relative py-20 sm:py-28 overflow-hidden" data-testid="bio-section">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(700px circle at 85% 20%, rgba(168,85,247,0.14), transparent 70%)" }} />
    <div className="max-w-4xl mx-auto px-5 sm:px-8 relative">
      <BioIntro />
      <BioTimeline />
      <BioObjective />
      <BioSkills />
    </div>
  </section>
);